import React, { useState } from "react";
import Modal from "./Modal";

console.log("Modal component:", Modal);

const Services = () => {
  const [selectedService, setSelectedService] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const services = [
    {
      id: 1,
      icon: "🌿",
      title: "Jardinage",
      subtitle: "Entretien professionnel de vos espaces verts",
      items: [
        "Tonte de pelouse",
        "Taille de haies",
        "Entretien d'espaces verts",
        "Désherbage",
      ],
      description:
        "Nos jardiniers professionnels transforment et entretiennent vos espaces verts avec expertise. Que ce soit pour un jardin résidentiel, des espaces communs ou des parcs d'entreprise, nous apportons soin et attention à chaque détail pour créer et maintenir un environnement verdoyant et agréable.",
      detailedItems: [
        {
          title: "Tonte de pelouse régulière",
          description:
            "Tonte professionnelle avec ramassage et évacuation des déchets verts",
        },
        {
          title: "Taille de haies et arbustes",
          description:
            "Taille précise pour maintenir la forme et la santé de vos végétaux",
        },
        {
          title: "Désherbage manuel ou chimique",
          description:
            "Élimination complète des mauvaises herbes selon vos préférences",
        },
        {
          title: "Entretien des massifs",
          description:
            "Soins des plantes, paillage et renouvellement des végétaux",
        },
        {
          title: "Aération et scarification",
          description: "Amélioration de la qualité du gazon et du sol",
        },
        {
          title: "Plantation et création",
          description:
            "Conception et réalisation de nouveaux espaces paysagers",
        },
      ],
      pricing: [
        { service: "Tonte pelouse (jusqu'à 100m²)", price: "à partir de 35€" },
        {
          service: "Taille de haies (par mètre linéaire)",
          price: "à partir de 8€/m",
        },
        { service: "Désherbage (par heure)", price: "25€/h" },
        { service: "Forfait entretien mensuel", price: "Sur devis" },
      ],
      advantages: [
        {
          icon: "🌱",
          title: "Équipe qualifiée",
          description: "Jardiniers professionnels expérimentés",
        },
        {
          icon: "🛠️",
          title: "Matériel pro",
          description: "Équipement moderne et performant",
        },
        {
          icon: "♻️",
          title: "Éco-responsable",
          description: "Évacuation et recyclage des déchets verts",
        },
      ],
    },
    {
      id: 2,
      icon: "🔧",
      title: "Bricolage",
      subtitle: "Tous travaux de bricolage à domicile",
      items: [
        "Petites réparations",
        "Montage de meubles",
        "Travaux de peinture",
        "Installation d'équipements",
      ],
      description:
        "Notre équipe de bricoleurs qualifiés intervient pour tous vos petits et grands travaux à domicile. De la réparation d'une porte qui grince au montage de meubles complexes, en passant par la peinture de vos pièces, nous sommes là pour vous simplifier la vie avec des interventions rapides et soignées.",
      detailedItems: [
        {
          title: "Montage de meubles",
          description:
            "Assemblage professionnel de tous types de meubles (IKEA, etc.)",
        },
        {
          title: "Petites réparations",
          description:
            "Fixations, serrurerie, plomberie légère, électricité simple",
        },
        {
          title: "Travaux de peinture",
          description:
            "Peinture murale, plafonds, boiseries avec finitions soignées",
        },
        {
          title: "Pose d'étagères et fixations",
          description:
            "Installation sécurisée de supports muraux et rangements",
        },
        {
          title: "Installation d'équipements",
          description: "Pose de luminaires, tringle à rideaux, miroirs, etc.",
        },
        {
          title: "Aménagement intérieur",
          description: "Optimisation et réorganisation de vos espaces",
        },
      ],
      pricing: [
        { service: "Montage meuble simple", price: "à partir de 40€" },
        { service: "Montage meuble complexe", price: "à partir de 80€" },
        { service: "Peinture (par m²)", price: "à partir de 15€/m²" },
        { service: "Intervention ponctuelle", price: "35€/h" },
      ],
      advantages: [
        {
          icon: "⚡",
          title: "Intervention rapide",
          description: "Disponibilité sous 48h",
        },
        {
          icon: "🎯",
          title: "Travail soigné",
          description: "Finitions professionnelles",
        },
        {
          icon: "🧰",
          title: "Tout équipé",
          description: "Outils et matériel fournis",
        },
      ],
    },
    {
      id: 3,
      icon: "📦",
      title: "Déménagement",
      subtitle: "Déménagement et manutention professionnels",
      items: [
        "Déménagement complet",
        "Manutention professionnelle",
        "Emballage sécurisé",
        "Transport de mobilier",
      ],
      description:
        "Spécialisés dans le déménagement résidentiel et professionnel, nous vous accompagnons dans toutes les étapes de votre projet. Notre équipe expérimentée manipule vos biens avec soin et professionnalisme, que ce soit pour un studio ou une grande maison, un local commercial ou des bureaux.",
      detailedItems: [
        {
          title: "Déménagement complet",
          description: "Prise en charge totale de A à Z avec notre équipe",
        },
        {
          title: "Emballage professionnel",
          description:
            "Cartons fournis, emballage soigné de vos biens fragiles",
        },
        {
          title: "Démontage et remontage",
          description:
            "Démontage et remontage de vos meubles sur les deux sites",
        },
        {
          title: "Protection des biens",
          description: "Couvertures, sangles et protection adaptée au mobilier",
        },
        {
          title: "Transport sécurisé",
          description: "Véhicules adaptés et conduite professionnelle",
        },
        {
          title: "Manutention lourde",
          description: "Piano, coffre-fort, objets volumineux et fragiles",
        },
      ],
      pricing: [
        { service: "Studio / F1 (local)", price: "à partir de 250€" },
        { service: "F2 / F3 (local)", price: "à partir de 450€" },
        { service: "Maison 4 pièces+", price: "Sur devis" },
        { service: "Forfait 2 déménageurs + camion", price: "80€/h" },
      ],
      advantages: [
        {
          icon: "💪",
          title: "Équipe pro",
          description: "Manutentionnaires expérimentés",
        },
        {
          icon: "🚚",
          title: "Véhicules adaptés",
          description: "Camions de toutes tailles",
        },
        {
          icon: "🛡️",
          title: "Assurance",
          description: "Garantie dommages incluse",
        },
      ],
    },
    {
      id: 4,
      icon: "✨",
      title: "Nettoyage",
      subtitle: "Nettoyage et entretien professionnel",
      items: [
        "Nettoyage résidentiel",
        "Entretien de locaux",
        "Nettoyage après travaux",
        "Vitrerie",
      ],
      description:
        "Notre service de nettoyage professionnel s'adapte à tous vos besoins, du simple entretien régulier au grand nettoyage après travaux. Équipe formée, produits professionnels écologiques et matériel de pointe pour un résultat impeccable qui respecte votre environnement et votre santé.",
      detailedItems: [
        {
          title: "Nettoyage résidentiel",
          description: "Entretien régulier ou ponctuel de votre domicile",
        },
        {
          title: "Nettoyage après travaux",
          description:
            "Élimination de la poussière, taches et résidus de chantier",
        },
        {
          title: "Entretien de bureaux",
          description: "Nettoyage professionnel de vos locaux d'entreprise",
        },
        {
          title: "Nettoyage de vitres",
          description: "Vitrerie intérieure et extérieure jusqu'à 3 étages",
        },
        {
          title: "Désinfection complète",
          description: "Traitement désinfectant des surfaces et sanitaires",
        },
        {
          title: "Nettoyage de fin de bail",
          description: "Remise en état complète pour récupérer votre caution",
        },
      ],
      pricing: [
        { service: "Nettoyage standard (par heure)", price: "25€/h" },
        { service: "Grand nettoyage (forfait 3h)", price: "à partir de 90€" },
        { service: "Nettoyage après travaux", price: "Sur devis" },
        { service: "Vitrerie (par m²)", price: "à partir de 8€/m²" },
      ],
      advantages: [
        {
          icon: "🧴",
          title: "Produits éco",
          description: "Produits écologiques et certifiés",
        },
        {
          icon: "👥",
          title: "Personnel qualifié",
          description: "Équipe formée et de confiance",
        },
        {
          icon: "⏰",
          title: "Horaires flexibles",
          description: "Intervention selon votre emploi du temps",
        },
      ],
    },
  ];

  const handleServiceClick = (service) => {
    console.log("Service clicked:", service);
    setSelectedService(service);
    setIsModalOpen(true);
    console.log("Modal should open now");
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setTimeout(() => setSelectedService(null), 300);
  };

  return (
    <>
      <section
        id="services"
        className="py-24 bg-white relative overflow-hidden"
      >
        <div className="deco-circle w-64 h-64 top-0 right-0 opacity-5"></div>

        <div className="max-w-7xl mx-auto px-6 lg:px-12 relative z-10">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold mb-4">
              Nos <span className="gradient-text">Services</span>
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Une gamme complète de services pour répondre à tous vos besoins
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {services.map((service) => (
              <div
                key={service.id}
                onClick={() => handleServiceClick(service)}
                className="service-card bg-white rounded-2xl p-8 shadow-xl border-2 border-gray-100 relative overflow-hidden cursor-pointer"
              >
                <div className="text-6xl mb-6">{service.icon}</div>
                <h3 className="text-2xl font-bold mb-4 text-gray-800">
                  {service.title}
                </h3>
                <ul className="space-y-2 text-gray-600 mb-6">
                  {service.items.map((item, index) => (
                    <li key={index} className="flex items-start">
                      <span className="text-orange-500 mr-2">•</span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
                <button
                  onClick={() => handleServiceClick(service)}
                  className="text-orange-500 font-semibold hover:text-orange-600 transition-colors inline-flex items-center"
                >
                  En savoir plus
                  <svg
                    className="w-4 h-4 ml-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Modal */}
      <Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        service={selectedService}
      />
    </>
  );
};

export default Services;
